import { render, staticRenderFns } from "./TopRankings.vue?vue&type=template&id=041bce49&scoped=true&"
import script from "./TopRankings.vue?vue&type=script&lang=js&"
export * from "./TopRankings.vue?vue&type=script&lang=js&"
import style0 from "./TopRankings.vue?vue&type=style&index=0&id=041bce49&lang=less&scoped=true&"
import style1 from "./TopRankings.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041bce49",
  null
  
)

export default component.exports